"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FireplaceSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path fill-rule="evenodd" d="M2 15.85C2 8.2 8.268 2 16 2s14 6.2 14 13.85v9.188a.968.968 0 0 1-.972.962H2.972A.967.967 0 0 1 2 25.038V15.85Zm4-.617C6 10.133 10.477 6 16 6s10 4.134 10 9.233v6.126c0 .354-.311.641-.694.641h-5.432A5.093 5.093 0 0 0 21 18.815c0-1.67-.98-2.849-1.826-3.863l-.22-.266c-.922-1.12-1.717-2.222-1.717-3.964a.72.72 0 0 0-.561-.704.725.725 0 0 0-.322 0c-1.3.293-2.09.935-2.527 1.753-.412.77-.46 1.616-.482 2.206l-.007.198c-.004.136-.008.25-.014.35a5.84 5.84 0 0 1-.61-.36.711.711 0 0 0-.89.073l-.002.002-.002.002-.007.007a4.692 4.692 0 0 0-.3.325 6.308 6.308 0 0 0-.62.89 6.661 6.661 0 0 0-.893 3.35c0 1.153.408 2.288 1.12 3.186H6.695C6.311 22 6 21.713 6 21.359v-6.126ZM5.786 28C5.352 28 5 28.448 5 29s.352 1 .786 1h20.428c.434 0 .786-.448.786-1s-.352-1-.786-1H5.786Z" clip-rule="evenodd" stroke="none"></path>';
var FireplaceSVG = function FireplaceSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.FireplaceSVG = FireplaceSVG;
FireplaceSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(FireplaceSVG);
exports.default = _default;